export default __webpack_public_path__ + "static/media/top-ten-10.0fddc393.svg";